module.exports = __webpack_public_path__ + "img/xjhrm.8214610c.png";